import React from "react";
import { Modal } from "antd";

export const AssetInquiriesModalContentComponent = (props) => {
  const { visible, onOk, content = null, title } = props;

  return (
    <>
      <Modal
        title={title}
        visible={visible}
        onOk={onOk}
        onCancel={onOk}
        width={1600}
        centered={false}
        closable={true}
      >
        {content}
      </Modal>
    </>
  );
};
